// React
import { useState } from "react"

// Types
type HandleType = string | string[]

export function useMultipleSelect(): {
  item: string[]
  handleData: (value: HandleType) => void
} {
  // Hooks
  const [item, setItem] = useState<string[]>([])

  // Functions
  const handleData = (value: HandleType): void => {
    // Vars
    let list = [...item]
    const index = item.findIndex(i => value === i)
    const data = item.find(i => value === i)

    if (typeof value === "string") {
      if (data) {
        list.splice(index, 1)
      } else {
        list.push(value)
      }
    } else {
      list = [...value]
    }

    setItem(list)
  }

  return { item, handleData }
}